import punycode from 'punycode';

export function throttle(func, ms) {

  let isThrottled = false,
    savedArgs,
    savedThis;

  function wrapper() {

    if (isThrottled) { // (2)
      savedArgs = arguments;
      savedThis = this;
      return;
    }

    func.apply(this, arguments); // (1)

    isThrottled = true;

    setTimeout(function() {
      isThrottled = false; // (3)
      if (savedArgs) {
        wrapper.apply(savedThis, savedArgs);
        savedArgs = savedThis = null;
      }
    }, ms);
  }

  return wrapper;
}

export function MyError(errors) {
  this.name = 'MyError';
  this.errors = errors;
  this.stack = (new Error).stack;
}

MyError.prototype = Object.create(Error.prototype);
MyError.prototype.constructor = MyError;

export function parseQueryString(query) {
  var vars = query.split("&");
  var query_string = {};
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    var key = decodeURIComponent(pair[0]);
    var value = decodeURIComponent(pair[1]);

    if (typeof query_string[key] === "undefined") {
      query_string[key] = decodeURIComponent(value);
    } else if (typeof query_string[key] === "string") {
      var arr = [query_string[key], decodeURIComponent(value)];
      query_string[key] = arr;
    } else {
      query_string[key].push(decodeURIComponent(value));
    }
  }
  return query_string;
}

export function getCookie(key) {
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookie.split(';');
  for (const cookie of cookiesArray) {
    const [cookieKey, cookieValue] = cookie.trim().split('=');
    if (cookieKey === key) {
      return cookieValue;
    }
  }
  return null;
}

export function copyObject(object) {
  return JSON.parse(JSON.stringify(object));
}

/*
  checking date in format dd-mm-yyyy
 */
export function isValidDate(dateString) {
  const dateParts = dateString.split('-');
  if (dateParts.length !== 3) return { isValid: false, message: 'incorrect string' };

  const day = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10);
  const year = parseInt(dateParts[2], 10);

  if (isNaN(day) || isNaN(month) || isNaN(year)) return { isValid: false, message: 'incorrect string' };

  if (month < 1 || month > 12) return { isValid: false, message: 'incorrect date' };

  const daysInMonth = new Date(year, month, 0).getDate();
  if (day < 1 || day > daysInMonth) return { isValid: false, message: 'incorrect date' };

  return true;
}

export function isValidName(value) {
  const regexp = new RegExp('^(?!.*[ -]{2})[а-яёА-ЯЁ}](?:[а-яёА-ЯЁ -]*[а-яёА-ЯЁ]){1,}$', 'u');
  return value.match(regexp) ? true : false;
}

export function isValidUnicodeEmail(value) {
  const list = value.split('@');
  if (list.length === 2) {
    const localPart = list[0];
    const domainPart = list[1];
    return validateEmailLocalPart(localPart) && validateEmailDomainPart(domainPart);
  } else {
    return false;
  }
}

export function validateEmailLocalPart(value) {
  /*
    локальная часть адреса
    - должна начинаться с буквы или цифры в кодировке ASCII
    - должна заканчиваться на букву или цифру в кодировке ASCII
    - из спецсимволов может содержать только точку (.), дефис (-) или подчеркивание (_)
    - не может содержать спецсимволы, идущие подряд
    - не может быть больше 64 символов
  */
  const regexp = new RegExp('^(?=.{1,64}$)[a-zA-Z0-9](?!.*(\\.\\.|--|__|\\._|\\.-|-\\.|-_|_-|_\\.))[a-zA-Z0-9._-]*[a-zA-Z0-9]$');
  return value.match(regexp) ? true : false;
}

export function validateEmailDomainPart(value) {
  /*
    доменная часть адреса
    - может состоять из букв и цифр в кодировке Unicode, точек (.) и дефисов (-)
    - не может содержать точки, идущие подряд
    - не может быть больше 255 символов
    - должна содержать как минимум одну точку (спецификация этого не требует, но вряд ли при регистрации у кого-то будет почта на домене первого уровня)
    - доменные имена должны начинаться и заканчиваться на букву или цифру в кодировке Unicode
  */
  const regexp = new RegExp('^(?=.*\\.)(?=\\p{L}|\\p{N})(?!.*\\.\\.)(?!.*(\\.-|-\\.))(?!^[.-])(?!.*[.-]$)(?:[\\p{L}\\p{N}.-]{0,253}[\\p{L}\\p{N}])?$', 'u');
  return value.match(regexp) ? true : false;
}

export function emailToPunycode(value) {
  const list = value.split('@');
  const localPart = list[0];
  const domainPart = list[1].toLowerCase();
  return [localPart, punycode.toASCII(domainPart)].join('@');
}

export function toUnicode(value) {
  return punycode.toUnicode(value);
}

/*
форматируется 11-значное число вида 79261234567
результат: +7 (926) 123-45-67
*/
export function formatPhoneNumber(phoneNumber) {
  const phoneString = phoneNumber.toString();
  return `+${phoneString.substring(0, 1)} (${phoneString.substring(1, 4)}) ${phoneString.substring(4, 7)}-${phoneString.substring(7, 9)}-${phoneString.substring(9, 11)}`;
}

/**
 * Склоняет слово в зависимости от числа
 * @param {number} number - число
 * @param {string[]} words - массив форм слова [1 день, 2 дня, 5 дней]
 * @returns {string} правильная форма слова для переданного числа
 */
export function declineWord(number, words) {
  const cases = [2, 0, 1, 1, 1, 2];
  const index = (number % 100 > 4 && number % 100 < 20) 
    ? 2 
    : cases[Math.min(number % 10, 5)];
  return words[index];
}


export function loadScript(id, src, args = { async: false, defer: true }) {
  return new Promise((resolve, reject) => {
    if (document.querySelector(`script[id="${id}"]`)) {
      resolve(true)
      return
    }

    const script = document.createElement('script')
    script.id = id
    script.src = src
    script.async = args.async
    script.defer = args.defer

    script.onload = () => {
      resolve(true)
    }

    script.onerror = () => {
      console.error(`Failed to load script src="${src}"`)
      reject(false)
    }

    document.head.appendChild(script)
  })
}

